import Footer from "../components/Footer";
import React, { useState } from "react";
import SheCellNoBubble from "../assets/images/she-cell-nobubble.png";
import POLYGONWE from "../assets/images/polygon-we.png";
import DARD from "../assets/images/card-black.png";
import Header from "../components/Header";
import B3 from "../assets/images/b3.png";
import FCA from "../assets/images/fca.png";
import BLOCKCHAIN from "../assets/images/blockchain.png";
import ANBINA from "../assets/images/anbina-short.png";
import Contact from "./Contact";
import Icon from "../components/icons/Icon";
import OptionModal from "../components/OptionsModal";

export const We = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
  
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);
  return (
    <div className="flex flex-col w-full ">
      <div
        className="flex flex-col  w-full justify-center items-center bg-[#081533]  lg:min-w-[1024px]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 10%, rgba(21, 83, 224, 1) 5%, rgba(8, 21, 51, 0.8) 40%, rgba(8, 21, 51, 0.5) 80%), radial-gradient(circle at 30% 50%, rgba(21, 83, 224, 0.6) 10%, rgba(8, 21, 51, 0.8) 50%, rgba(8, 21, 51, 0.3) 80%), radial-gradient(circle at 70% 70%, rgba(21, 83, 224, 0.7) 10%, rgba(8, 21, 51, 0.8) 50%, rgba(8, 21, 51, 0.4) 80%)",
          position: "relative",
        }}
      >
        <Header />
        <div className="flex h-fit w-full lg:w-[900px] flex-col lg:flex-row items-center justify-center gap-8 mt-12">
          <div className="text-left text-white p-8 lg:p-0 lg:mb-0">
         <div className="mb-10"><button className="bg-transparent border border-[#0f3ca3] h-12 w-54 text-[#79A2FF] py-2 px-6 rounded-full hover:bg-[#0f3ca3]-100">
          Sobre a Wii Ascend
            </button>
            </div>
            <h2 className="text-3xl font-bold mb-6">
              Uma fintech feita para o agora. E preparada para o amanhã
            </h2>
            <p className="text-xl text-[#79A2FF] mb-6">
            Fundada em 2025, a Wii Ascend nasceu com <br />uma missão clara: unir o melhor do mercado <br />financeiro tradicional com a revolução digital.
            </p>
            <p className="text-lg text-white/80 mb-1 lg:mb-6">
            Somos pioneiros em soluções Web3 que colocam a liberdade nas mãos das pessoas. 
            </p>
            
          </div>

          <div className="hidden lg:block">
            <img
              src={SheCellNoBubble}
              alt="Mulher segurando um celular"
              className="w-[800px] h-auto rounded-xl"
            />
          </div>
        </div>
        <div>

        <div className="flex flex-col gap-4 w-fit p-8 lg:p-0 lg:w-full  mt-10">


            <div className="flex flex-col lg:flex-row gap-4">


              <div className="flex flex-col items-center justify-center bg-[#887443]/70 lg:h-75 lg:w-[400px] text-white p-6 rounded-xl">
              <img
              src={FCA}
              alt="FCA"
              className="w-[150px] h-[65px] rounded-xl"
            />
              
                <p className="text-lg text-white/80 text-center m-4">
                Contamos com a supervisão da FCA, uma das principais autoridades financeiras do mundo, reforçando nosso compromisso com transparência e excelência regulatória.
                </p>
              </div>


              <div className="flex flex-col items-center justify-center  bg-[#887443]/80  lg:h-75 lg:w-[400px] text-white p-6 rounded-xl">
                <img
                  src={ANBINA}
                  alt="ANBINA"
                  className="w-[150px] h-[65px] rounded-xl "
                />
                <p className="text-lg text-white/80 text-center m-4">
                Atuamos com transparência e responsabilidade, seguindo as diretrizes da autorregulação da ANBIMA para a distribuição de produtos de investimentos.
                </p>
              </div>
              
            </div>

            <div className="flex flex-col  items-center justify-center lg:flex-row gap-4">
            <div className="flex flex-col  items-center justify-center bg-[#887443]/70 lg:h-75 lg:w-[400px] text-white p-6 rounded-xl ">
                <img
                  src={B3}
                  alt="B3"
                  className="w-[150px] h-[65px]  rounded-xl"
                />
                <p className="text-lg text-white/80 text-center m-4">
                Temos o respaldo da B3, a principal infraestrutura do mercado financeiro brasileiro,  reforçando a nossa solidez, nossa credibilidade e nosso compromisso com suas transações.
                </p>
              </div>
             
             

              <div className="flex flex-col items-center justify-center  bg-[#887443]/70 lg:h-75 lg:w-[400px] text-white p-6 rounded-xl">
                  <img
                  src={BLOCKCHAIN}
                  alt="BLOCKCHAIN"
                  className="w-[150px] h-[65px]  rounded-xl m-4"
                />
                <p className="text-lg text-white/80 text-center ">
                Operamos com a licença para uso e aplicação da tecnologia blockchain, para garantir  segurança, transparência e integridade em cada transação, onde todos os dados são registrados de forma imutável e auditável.
                </p>
              </div>
            </div>
          </div>
        </div>


        <div className="flex flex-col items-center justify-center text-center text-white p-1 lg:p-8">
          {/* <div> */}
            {/* <img
              src={CONTACT}
              alt="Imagem do atendimento"
              className="w-fit lg:w-[600px] h-fit lg:h-[400px] hidden lg:block "
            />
          </div>

          <h2 className=" text-3xl text-[#887443] font-bold mb-6 my-6">
            Atendimento humano.
          </h2>
          <h2 className="k w-[400px]  text-3xl font-bold mb-6">
            Porque você merece mais que um chatbot
          </h2>
          <p className="w-[400px] text-lg mb-6">
            A dúvida bateu? Precisa de orientação? Nosso time está sempre pronto
            para te ajudar com empatia e conhecimento real.
          </p> */}

          {/* <div className="flex flex-row gap-8 mb-6  "> */}
            {/* <a
              href="https://wa.me/554891081427"
              target="_blank"
              className="bg-[#887443] text-white items-center justify-center rounded-full"
            >
              <Icon name="Whatsapp" className="text-white w-8 h-8 m-3" />
            </a> */}
            {/* <a
              href="https://www.linkedin.com/company/wiiascend/posts/?feedView=all"
              target="_blank"
              className="bg-[#887443] rounded-full"
            >
              <Icon name="Linkedin" className="text-white w-8 h-8 m-3" />
            </a> */}
            {/* <a
                href="https://t.me/seu-usuario"
                target="_blank"
                className="bg-[#887443] rounded-full"
              >
                <Icon name="Telegram" className="text-white w-8 h-8 m-3" />
              </a> */}
            {/* <a
              href="https://www.instagram.com/wiiascend?igsh=aW5tZG1vcHU1Z2R4"
              target="_blank"
              className="bg-[#887443] rounded-full"
            >
              <Icon name="Instagram" className="text-white w-8 h-8 m-3" />
            </a> */}
            {/* <a
              href="mailto:weslleyfernando71609@gmail.com?subject=Preciso%20de%20ajuda"
              className="bg-[#887443] rounded-full"
              rel="noopener noreferrer"
            >
              <Icon name="Email" className="text-white w-8 h-8 m-3" />
            </a> */}
          {/* </div> */}

          <button
          onClick={openModal}
           className="bg-[#887443] text-white py-2 px-6 rounded-full ">
            Fale com a Wii Ascend agora
          </button>
        </div>

        <div className="flex flex-col lg:flex-row  gap-8  items-center justify-center  py-8 lg:py-16 px-8">
          <div className=" mb-4 lg:mb-0">
            <img
              src={DARD}
              alt="Imagem dos cartões"
              className="w-[470px] h-auto rounded-xl"
            />
          </div>

          <div className="w-fit  lg:w-[500px] bg-[#887443]/20  rounded-2xl text-white text-left z-10">
          <div className="flex w-full lg:w-[500px] z-30 items-right justify-end">
           <img
              src={POLYGONWE}
              alt="POLYGONWE"
              className="w-[80px] h-autorounded-xl z-30  items-right justify-right"
            />
             </div>
            <div className="z-20 p-10">
              <h2 className="text-xl  font-bold mb-6">
              Combinamos segurança, conformidade e inovação para garantir que
              você tenha controle total sobre seus ativos e transações, alinhado
              às tendências da nova economia digital.
            </h2>
            <p className="text-lg mb-6">
              Nossa visão é a empoderar indivíduos e empresas, proporcionando
              acesso seguro, confiável e transparente a soluções financeiras de
              ponta.
            </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />

        <OptionModal isOpen={isModalOpen} closeModal={closeModal} />
    </div>
  );
};
